import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './BarraContainer.css'; // Asegúrate de crear y ajustar este archivo CSS según tus necesidades
import AddIcon from '../../icons/1a.png'; // Icono de agregar
import DeleteIcon from '../../icons/2a.png'; // Icono de eliminar
import ExportIcon from '../../icons/3a.png'; // Icono de exportar a XLS
import ImportIcon from '../../icons/4a.png'; // Icono de importar XLS
import EditIcon from '../../icons/5a.png'; // Icono de editar
import SearchIcon from '../../icons/6a.png'; // Icono de buscar
import FilterIcon from '../../icons/7a.png'; // Icono de filtro
import ReturnIcon from '../../icons/9a.png'; // Icono de regresar
import { useDispatch } from 'react-redux';
import { selectSubMenu } from '../../actions';

const BarraContainer = ({ buttonList, searchTerm, setSearchTerm, filterField, setFilterField, columns, handleButtonClick, navigationHistory, showChart, setShowChart }) => {
  const dispatch = useDispatch();
  const handleReturn = () => {
    dispatch(selectSubMenu(navigationHistory[navigationHistory.length - 2]));
  }

  return (
    <div className="barra-container">
      <div className="button-bar">
        <div>
          {buttonList.includes('add') && (
            <button className="icon-button" onClick={() => handleButtonClick('add')} title="Agregar">
              <img src={AddIcon} alt="Agregar" />
            </button>
          )}
          {buttonList.includes('delete') && (
            <button className="icon-button" onClick={() => handleButtonClick('delete')} title="Eliminar">
              <img src={DeleteIcon} alt="Eliminar" />
            </button>
          )}
          <button className="icon-button" onClick={() => handleButtonClick('export')} title="Exportar a XLS">
            <img src={ExportIcon} alt="Exportar a XLS" />
          </button>
          {buttonList.includes('import') && (
            <button className="icon-button" onClick={() => handleButtonClick('import')} title="Importar XLS">
              <img src={ImportIcon} alt="Importar XLS" />
            </button>
          )}
          {buttonList.includes('edit') && (
            <button className="icon-button" onClick={() => handleButtonClick('edit')} title="Editar">
              <img src={EditIcon} alt="Editar" />
            </button>
          )}
        </div>
        {typeof showChart !== 'undefined' && typeof setShowChart === 'function' && (
          <div className="iconos">
            <input
              title ='Ver Gráfico'
              type="checkbox"
              id="showChart"
              checked={showChart}
              onChange={(e) => setShowChart(e.target.checked)}
            />
          </div>
        )}
        {columns && columns.length > 0 && (
          <>
            <div className="iconos">
              <img src={FilterIcon} alt="Filtro" title="Filtro" />
            </div>
            <select
              className="search-input"
              value={filterField}
              onChange={(e) => setFilterField(e.target.value)}
              title="Campo de filtro"
            >
              {columns.map((col) => (
                <option key={col.field} value={col.field}>{col.header}</option>
              ))}
            </select>
            <div className="iconos">
              <img src={SearchIcon} alt="Buscar" title="Buscar" />
            </div>
            <input
              className="search-input"
              type="text"
              placeholder="Buscar..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            
          </>
        )}
        {navigationHistory && navigationHistory.length > 1 && (
          <button className="icon-button" onClick={handleReturn} title="Regresar">
            <img src={ReturnIcon} alt="Regresar" />
          </button>
        )}
      </div>
    </div>
  );
};

BarraContainer.propTypes = {
  buttonList: PropTypes.arrayOf(PropTypes.string).isRequired,
  searchTerm: PropTypes.string,
  setSearchTerm: PropTypes.func,
  filterField: PropTypes.string,
  setFilterField: PropTypes.func,
  columns: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired,
  })),
  handleButtonClick: PropTypes.func.isRequired,
  navigationHistory: PropTypes.arrayOf(PropTypes.object).isRequired,
  showChart: PropTypes.bool,
  setShowChart: PropTypes.func,
};

BarraContainer.defaultProps = {
  columns: [],
  searchTerm: '',
  setSearchTerm: () => {},
  filterField: '',
  setFilterField: () => {},
  showChart: undefined,
  setShowChart: undefined,
};

export default BarraContainer;
